import React from "react";
import TableNoBorder from "../../../components/tables/TableNoBorder";
import PlusButton from "../../../components/PlusButton";
import MinusButton from "../../../components/MinusButton";
import ProdCodeFormProducerCodeSection from "./ProdCodeFormProducerCodeSection";
import SelectInput from "../../../components/SelectInput";

const localCustomStyles = {
  cells: {
    style: {
      paddingLeft: "1px", // override the cell padding for data cells
      paddingRight: "2px",
    },
  },
};

const ProducerAddressTable = ({
  data,
  tableName,
  handleRemovecarrierAddress,
  handleAddcarrierProducerCodeRow,
  carrierProducerCodeData = [],
  handleContactInputs,
  handleAddProducerCodeRow,
  handleRemoveProducerCodeRow,
  handleProducerCodeInputs,
  loboptions,
  distChannelOpts,
  addMainForm,
  agencies,
  handleMACheckBox,
  handleIsFranchise,
}) => {
  const handlePlusOnClick = (row, tableName) => {
    if (tableName === "ProducerAddressTable") {
      handleAddcarrierProducerCodeRow(row, tableName);
    }
  };

  const columns = [
    {
      name: "Actions",
      width: 10,
      center: true,
      cell: (row) => (
        <div
          className={`${row.RowId === 1 && "pb-1"} w-full -mt-2.5 text-center`}
        >
          {row.RowId === 1 && (
            <div className="font-bold border-b-2 mb-1 text-quinary">Action</div>
          )}
          {row.RowId !== 1 ? (
            <div className="mt-2">
              <MinusButton
                className="ml-7"
                onClick={() => handleRemovecarrierAddress(row, tableName)}
              />
            </div>
          ) : (
            <div className="mt-2">
              <PlusButton
                className="ml-7"
                onClick={() => handlePlusOnClick(row, tableName)}
              />
            </div>
          )}
        </div>
      ),
      sortable: true,
    },
    {
      name: (
        <div>
          Office: <span className="text-red-500">*</span>
        </div>
      ),
      cell: (row) => (
        <div className={`${row.RowId === 1 && "pb-2"} w-full`}>
          {row.RowId === 1 && (
            <div className="font-bold border-b-2 mb-1 text-quinary">
              Office: {<span className="text-red-500">*</span>}
            </div>
          )}
          <SelectInput
            options={agencies.filter((s) =>
              data.state
                .split(",")
                .map((item) => item.trim())
                .includes(s.state)
            )}
            value={row.States}
            onChange={(selectedOptions) => {
              handleProducerCodeInputs(
                tableName,
                "OfficeCodeStoreNumber",
                selectedOptions != null ? selectedOptions.value : null,
                data.masterCarrierId,
                data.state,
                row.RowId,
                row.producerCodeRowId == null ? 1 : row.producerCodeRowId,
                addMainForm
              );
            }}
          />
        </div>
      ),
      sortable: true,
      width: "15%",
    },
    {
      name: "Producer Codes",
      cell: (row) => {
        return (
          <div className="mt-10">
            <ProdCodeFormProducerCodeSection
              tableName={tableName}
              handleContactInputs={handleContactInputs}
              handleAddProducerCodeRow={handleAddProducerCodeRow}
              handleRemoveProducerCodeRow={handleRemoveProducerCodeRow}
              handleProducerCodeInputs={handleProducerCodeInputs}
              carrierProducerCodeData={
                carrierProducerCodeData[parseInt(row.RowId) - 1]
              }
              masterCarrierId={data == null ? "" : data.masterCarrierId}
              state={data == null ? "" : data.state}
              rowId={row.RowId}
              loboptions={loboptions}
              distChannelOpts={distChannelOpts}
              addMainForm={addMainForm}
              handleMACheckBox={handleMACheckBox}
              handleIsFranchise={handleIsFranchise}
            />
          </div>
        );
      },
      sortable: true,
      width: "80%",
    },
  ];

  const emptyRow = [{ Address: "", City: "", ProducerCodes: "" }];
  return (
    <TableNoBorder
      highlightOnHover={false}
      customStyles={localCustomStyles}
      noTableHead={true}
      columns={columns}
      data={carrierProducerCodeData ? carrierProducerCodeData : emptyRow}
    />
  );
};

export default ProducerAddressTable;
